<template>
  <div class="courses-section">

    <div class="sec " @click="openModal('DoreJameKonkoor1404')">
      <img alt="course" src="../assets/images/courses/DoreJameKonkoor1404-Big.jpg">
      <i class="icon-plus-circle"></i>
    </div>
    <div class="sec " @click="openModal('DoreJameDahom1404')">
      <img alt="course" src="../assets/images/courses/DoreJameDahom1404-Big.jpg">
      <i class="icon-plus-circle"></i>
    </div>
    <div class="sec " @click="openModal('DoreJameYazdahom1404')">
      <img alt="course" src="../assets/images/courses/DoreJameYazdahom1404-Big.jpg">
      <i class="icon-plus-circle"></i>
    </div>
    <div class="sec " @click="openModal('DoreOmoumiDavazdahom1404')">
      <img alt="course" src="../assets/images/courses/DoreOmoumiDavazdahom1404-Big.jpg">
      <i class="icon-plus-circle"></i>
    </div>
    <div class="sec " @click="openModal('DoreJameEbtedayi6ta91404')">
      <img alt="course" src="../assets/images/courses/DoreJameEbtedayi6ta91404-Big.png">
      <i class="icon-plus-circle"></i>
    </div>
    <div class="sec " @click="openModal('DoreIQSheshom1404')">
      <img alt="course" src="../assets/images/courses/DoreIQSheshom1404-Big.jpg">
      <i class="icon-plus-circle"></i>
    </div>
    <div class="sec " @click="openModal('DoreIQNohom1404')">
      <img alt="course" src="../assets/images/courses/DoreIQNohom1404-Big.jpg">
      <i class="icon-plus-circle"></i>
    </div>
    <div class="sec " @click="openModal('DoreJame6ta91404')">
      <img alt="course" src="../assets/images/courses/DoreJame6ta91404-Big.jpg">
      <i class="icon-plus-circle"></i>
    </div>

    <component v-if="courseModal" :is="courseModal" @close="activeModal = false;"  :active-course="activeModal" />

  </div>
</template>

<script>
import DoreJameKonkoor1404 from "@/components/modal/coursesModal/DoreJameKonkoor1404.vue";
import DoreIQNohom1404 from "@/components/modal/coursesModal/DoreIQNohom1404.vue";
import DoreJameEbtedayi6ta91404 from "@/components/modal/coursesModal/DoreJameEbtedayi6ta91404.vue";
import DoreIQSheshom1404 from "@/components/modal/coursesModal/DoreIQSheshom1404.vue";
import DoreJameDahom1404 from "@/components/modal/coursesModal/DoreJameDahom1404.vue";
import DoreJameYazdahom1404 from "@/components/modal/coursesModal/DoreJameYazdahom1404.vue";
import DoreOmoumiDavazdahom1404 from "@/components/modal/coursesModal/DoreOmoumiDavazdahom1404.vue";
import DoreJame6ta91404 from "@/components/modal/coursesModal/DoreJame6ta91404.vue";

export default {

  name: "DesktopMainCourses1403",
  components: {
    DoreJameKonkoor1404,
    DoreJameDahom1404,
    DoreJameYazdahom1404,
    DoreOmoumiDavazdahom1404,
    DoreIQNohom1404,
    DoreIQSheshom1404,
    DoreJame6ta91404,
    DoreJameEbtedayi6ta91404,

  },
  data() {
    return {
      courseModal: '',
      activeModal :false
    }
  },
  methods:{
    openModal(value){
        this.courseModal = value;
        this.activeModal = !this.activeModal;
    }
  }
}
</script>

<style lang="scss" scoped>
.courses-section {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  @include media-breakpoint-down(md){
    justify-content: center;
  }
  .sec {
    cursor: pointer;
    width: 23%;
    display: flex;
    justify-content: center;
    border-radius: 10px;
    position: relative;
    transition: all .2s ease-in-out;
    margin: 10px 5px 0;
    @include media-breakpoint-down(md){
      width: 85%;
      margin-bottom: 1rem;
    }

    &:hover {
      transform: scale(1.05);
    }

    img {
      width: 100%;
      border-radius: 8px;
    }

    span, i {
      position: absolute;
      color: white;
    }

    span {
      padding: 20px 15px;
      text-align: center;
      width: 100%;
      font-size: 1.2rem;
      font-weight: 800;
    }

    i {
      bottom: 15px;
      left: 15px;
      font-size: 1.5rem;

    }
  }
}
</style>
